import { Grid } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import CountWithTextCard from '../../../analytics/components/countWithTextCard';
import { ILeadDTO } from '../jobs/types/postgreJobsDTO';
import { ILeadWidgetProp } from '../jobs/types/postgreJobsWidgetProp';

import { defaultLeadWidgetData } from './leadHelper';
import usePostgreLeadWidgetsData from './useLeadWidgetData';

const LeadCountMetric = ({ query, title }: ILeadWidgetProp) => {
  const { widgetData } = usePostgreLeadWidgetsData<ILeadDTO>(query, defaultLeadWidgetData);

  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      {!widgetData.countByStatus && (
        <Grid item xs={2} ml={10}>
          <CountWithTextCard variant="h3" count={widgetData.count ?? 0} fullHeight text="" />
        </Grid>
      )}
      {widgetData.countByStatus && isEmpty(widgetData.countByStatus) ? (
        <Grid item xs={2} ml={10}>
          <CountWithTextCard variant="h3" count={0} fullHeight text="" />
        </Grid>
      ) : (
        Object.keys(widgetData.countByStatus ?? {}).map((leadStatus) => (
          <Grid item key={leadStatus} xs={2} ml={10}>
            <CountWithTextCard
              variant="h3"
              count={widgetData.countByStatus?.[leadStatus] ?? 0}
              fullHeight
              text={leadStatus}
            />
          </Grid>
        ))
      )}
    </Grid>
  );
};

export default LeadCountMetric;
